import { MessageCircle } from "lucide-react";
import { whatsappUrl } from "../lib/whatsapp";

export default function ServiceCard({ service, mode = "summary" }) {
  const Icon = service.icon;
  const message = `Hi Ben, I would like to ask about ${service.title} from Job Boost by Ben.`;
  return (
    <article className="service-card fade-in" data-testid={`${mode}-${service.slug}-service-card`}>
      {Icon && <span className="card-icon" data-testid={`${mode}-${service.slug}-service-icon`}><Icon size={22} /></span>}
      <h3 data-testid={`${mode}-${service.slug}-service-title`}>{service.title}</h3>
      <p data-testid={`${mode}-${service.slug}-service-text`}>{service.text || service.intro}</p>
      <a className="btn btn-secondary" href={whatsappUrl(message)} target="_blank" rel="noopener noreferrer" data-testid={`${mode}-${service.slug}-ask-button`}>
        <MessageCircle size={18} /> Ask about this service
      </a>
    </article>
  );
}